<template>
  <div class="mt-2" v-if="account">
    <v-btn
      v-if="!kollelForms.length || kollelForms.length == 1"
      color="success"
      class="mt-0"
      small
      @click="openKollelApplication"
      >Open Kollel Application</v-btn
    >
    <v-btn
      outline
      v-if="kollelForms.length > 1"
      v-for="form in kollelForms"
      color="success"
      class="mt-0"
      small
      @click="openKollelApplication({ id: form.id })"
      >Kollel Application {{ form.date | date }}</v-btn
    >
    <div
      class="headline text-success text-xs-center mb-3"
      v-if="account.isRegistered"
    >
      Registered
    </div>
    <div
      class="headline text-warning text-xs-center mb-3"
      v-if="!account.isRegistered"
    >
      Not Registered
    </div>

    <div v-if="registrationRequirments.length">
      <div v-for="(requirment, index) in registrationRequirments" class="mx-2">
        <v-layout row class="pt-2">
          <v-icon
            class="mr-3 ml-1"
            dark
            :color="requirment.isCompleted ? 'success' : 'red'"
            >{{
              requirment.isCompleted ? "mdi-check-circle" : "mdi-alert-circle"
            }}</v-icon
          >
          <div class="title">{{ requirment.reqType }}</div>
        </v-layout>
        <div
          class="ml-4 pl-2"
          v-html="getRequirmentDescription(requirment)"
        ></div>
        <v-divider
          class="pb-2 mt-2"
          v-if="index + 1 < registrationRequirments.length"
          :key="index"
        >
        </v-divider>
      </div>
    </div>

    <div class="application-info-section mt-4" ref="applicationInfoSection">
      <div
        v-if="!applicationInfoExpanded"
        class="application-info-toggle"
        @click="toggleApplicationInfo"
      >
        <span class="application-info-toggle-title">
          Application Information ({{ applicationInfoFilledCount }})
        </span>
        <v-icon class="application-info-caret ml-1" size="20" color="#4caf50">
          mdi-chevron-down
        </v-icon>
        <v-progress-circular
          v-if="applicationInfoLoading"
          indeterminate
          color="success"
          size="16"
          width="2"
          class="ml-2"
        ></v-progress-circular>
      </div>

      <div v-else class="application-info-box">
        <div class="application-info-box-header" @click="toggleApplicationInfo">
          <span class="application-info-box-title">
            Application Information ({{ applicationInfoFilledCount }})
          </span>
          <v-icon class="application-info-caret ml-1" size="20" color="#4caf50">
            mdi-chevron-up
          </v-icon>
          <v-spacer></v-spacer>
          <v-btn
            class="mr-0 my-0"
            small
            color="success"
            @click.stop="openApplicationInfoDialog"
          >
            <v-icon left small>mdi-pencil</v-icon>
            Edit
          </v-btn>
        </div>
        <div class="application-info-box-body pa-3">
          <div v-if="applicationInfoLoading" class="text-center pa-4">
            <v-progress-circular
              indeterminate
              color="success"
              size="40"
            ></v-progress-circular>
            <div class="mt-2 text--secondary">Loading application info...</div>
          </div>
          <v-layout
            v-else-if="applicationInfo"
            row
            wrap
            style="margin-left: -8px; margin-right: -8px;"
          >
        <!-- Column 1 -->
        <v-flex style="flex: 0 0 33%; max-width: 33%;" class="px-2 ml-2">
          <!-- Father Information -->
          <div class="mb-3">
            <div class="font-weight-bold mb-2">טאטע</div>
            <div
              v-if="
                !applicationInfo.fatherCity &&
                  !applicationInfo.fatherSchool &&
                  !applicationInfo.fatherYeshivahKetana &&
                  !applicationInfo.fatherYeshivahGedolah
              "
              class="text--secondary"
              style="font-size: 12px; font-style: italic;"
            >
              No info filled...
            </div>
            <div class="detail-row" v-if="applicationInfo.fatherCity">
              <span class="label">Father City:</span>
              <span>{{ applicationInfo.fatherCity }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.fatherSchool">
              <span class="label">?טאטע איז א תלמיד פון חדר:</span>
              <span>{{ applicationInfo.fatherSchool }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.fatherYeshivahKetana">
              <span class="label">?טאטע איז א תלמיד פון ישיבה קטנה:</span>
              <span>{{ applicationInfo.fatherYeshivahKetana }}</span>
            </div>
            <div
              class="detail-row"
              v-if="applicationInfo.fatherYeshivahGedolah"
            >
              <span class="label">?טאטע איז א תלמיד פון ישיבה גדולה:</span>
              <span>{{ applicationInfo.fatherYeshivahGedolah }}</span>
            </div>
          </div>

          <!-- Mother Information -->
          <div class="mb-3">
            <div class="font-weight-bold mb-2">מאמע</div>
            <div
              v-if="
                !applicationInfo.motherSchool &&
                  !applicationInfo.motherGraduatedYear
              "
              class="text--secondary"
              style="font-size: 12px; font-style: italic;"
            >
              No info filled...
            </div>
            <div class="detail-row" v-if="applicationInfo.motherSchool">
              <span class="label">?מאמע איז תלמידה פון:</span>
              <span>{{ applicationInfo.motherSchool }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.motherGraduatedYear">
              <span class="label">?וועלכע יאר גענדיגט די 11 טע קלאס:</span>
              <span>{{ applicationInfo.motherGraduatedYear }}</span>
            </div>
          </div>

          <!-- Landlord -->
          <div class="mb-3">
            <div class="font-weight-bold mb-2">Landlord</div>
            <div
              v-if="
                !applicationInfo.landlord &&
                  !applicationInfo.landlordPhone
              "
              class="text--secondary"
              style="font-size: 12px; font-style: italic;"
            >
              No info filled...
            </div>
            <div class="detail-row" v-if="applicationInfo.landlord">
              <span class="label">Landlord:</span>
              <span>{{ applicationInfo.landlord }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.landlordPhone">
              <span class="label">Landlord Phone:</span>
              <span>{{ applicationInfo.landlordPhone }}</span>
            </div>
          </div>

          <!-- Emergency Contact -->
          <div class="mb-3">
            <div class="font-weight-bold mb-2">Emergency Contact</div>
            <div
              v-if="
                !applicationInfo.inCaseOfEmergencyName &&
                  !applicationInfo.inCaseOfEmergencyPhone
              "
              class="text--secondary"
              style="font-size: 12px; font-style: italic;"
            >
              No info filled...
            </div>
            <div
              class="detail-row"
              v-if="applicationInfo.inCaseOfEmergencyName"
            >
              <span class="label">Emergency Contact Name:</span>
              <span>{{ applicationInfo.inCaseOfEmergencyName }}</span>
            </div>
            <div
              class="detail-row"
              v-if="applicationInfo.inCaseOfEmergencyPhone"
            >
              <span class="label">Emergency Contact Phone #:</span>
              <span>{{ applicationInfo.inCaseOfEmergencyPhone }}</span>
            </div>
          </div>

          <!-- Country -->
          <div class="mb-3" v-if="applicationInfo.country">
            <div class="font-weight-bold mb-2">Country</div>
            <div class="detail-row">
              <span class="label">Country:</span>
              <span>{{ applicationInfo.country }}</span>
            </div>
          </div>
        </v-flex>

        <!-- Column 2 -->
        <v-flex style="flex: 0 0 33%; max-width: 33%;" class="px-2">
          <!-- Work Information -->
          <div class="mb-3">
            <div class="font-weight-bold mb-2">ארבעט</div>
            <div
              v-if="
                !applicationInfo.workPlaceOrBoss &&
                  !applicationInfo.workBoss &&
                  !applicationInfo.workType &&
                  !applicationInfo.workAddress &&
                  !applicationInfo.workPhone &&
                  !applicationInfo.workPosition &&
                  !applicationInfo.yearsInPosition &&
                  !applicationInfo.wifeWorkPlaceOrBoss &&
                  !applicationInfo.wifeWorkBoss &&
                  !applicationInfo.wifeWorkType &&
                  !applicationInfo.wifeWorkAddress &&
                  !applicationInfo.wifeWorkPhone &&
                  !applicationInfo.wifeWorkPosition &&
                  !applicationInfo.wifeYearsInPosition
              "
              class="text--secondary"
              style="font-size: 12px; font-style: italic;"
            >
              No info filled...
            </div>
            <!-- Father's Work -->
            <div class="font-weight-bold mb-1 mt-2" style="font-size: 12px;">טאטע'ס ארבעט</div>
            <div class="detail-row" v-if="applicationInfo.workPlaceOrBoss">
              <span class="label">ארבעט:</span>
              <span>{{ applicationInfo.workPlaceOrBoss }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.workBoss">
              <span class="label">נאמען פון בעה''ב:</span>
              <span>{{ applicationInfo.workBoss }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.workType">
              <span class="label">Work Type:</span>
              <span>{{ applicationInfo.workType }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.workAddress">
              <span class="label">Work Address:</span>
              <span>{{ applicationInfo.workAddress }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.workPhone">
              <span class="label">Work Phone #:</span>
              <span>{{ applicationInfo.workPhone }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.workPosition">
              <span class="label">Work Position:</span>
              <span>{{ applicationInfo.workPosition }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.yearsInPosition">
              <span class="label">Years In Position:</span>
              <span>{{ applicationInfo.yearsInPosition }}</span>
            </div>
            <!-- Mother's Work -->
            <div class="font-weight-bold mb-1 mt-2" style="font-size: 12px;">מאמע'ס ארבעט</div>
            <div class="detail-row" v-if="applicationInfo.wifeWorkPlaceOrBoss">
              <span class="label">ארבעט:</span>
              <span>{{ applicationInfo.wifeWorkPlaceOrBoss }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.wifeWorkBoss">
              <span class="label">נאמען פון בעה''ב:</span>
              <span>{{ applicationInfo.wifeWorkBoss }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.wifeWorkType">
              <span class="label">Work Type:</span>
              <span>{{ applicationInfo.wifeWorkType }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.wifeWorkAddress">
              <span class="label">Work Address:</span>
              <span>{{ applicationInfo.wifeWorkAddress }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.wifeWorkPhone">
              <span class="label">Work Phone #:</span>
              <span>{{ applicationInfo.wifeWorkPhone }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.wifeWorkPosition">
              <span class="label">Work Position:</span>
              <span>{{ applicationInfo.wifeWorkPosition }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.wifeYearsInPosition">
              <span class="label">Years In Position:</span>
              <span>{{ applicationInfo.wifeYearsInPosition }}</span>
            </div>
          </div>
        </v-flex>

        <!-- Column 3 -->
        <v-flex style="flex: 0 0 33%; max-width: 33%;" class="px-2">
          <!-- ביהמ"ד -->
          <div class="mb-3">
            <div class="font-weight-bold mb-2">ביהמ"ד</div>
            <div
              v-if="
                !applicationInfo.shabbatSynagogue &&
                  !applicationInfo.weekdaySynagogue &&
                  !applicationInfo.dayan &&
                  applicationInfo.isSatmarMember === null
              "
              class="text--secondary"
              style="font-size: 12px; font-style: italic;"
            >
              No info filled...
            </div>
            <div class="detail-row" v-if="applicationInfo.shabbatSynagogue">
              <span class="label">וואכן ביהמ''ד:</span>
              <span>{{ applicationInfo.shabbatSynagogue }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.weekdaySynagogue">
              <span class="label">שבת ביהמ''ד:</span>
              <span>{{ applicationInfo.weekdaySynagogue }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.dayan">
              <span class="label">דיין:</span>
              <span>{{ applicationInfo.dayan }}</span>
            </div>
            <div
              class="detail-row"
              v-if="applicationInfo.isSatmarMember !== null"
            >
              <span class="label">קיט''ל מעמבער:</span>
              <span>{{ applicationInfo.isSatmarMember ? "Yes" : "No" }}</span>
            </div>
          </div>

          <!-- קינדער -->
          <div class="mb-3">
            <div class="font-weight-bold mb-2">קינדער</div>
            <div
              v-if="
                !applicationInfo.kidsAtHome &&
                  applicationInfo.kidsInOtherSchool === null &&
                  !applicationInfo.otherSchool &&
                  !applicationInfo.playGroup
              "
              class="text--secondary"
              style="font-size: 12px; font-style: italic;"
            >
              No info filled...
            </div>
            <div class="detail-row" v-if="applicationInfo.kidsAtHome">
              <span class="label">?וויפיל קינדער האט איר אין שטוב:</span>
              <span>{{ applicationInfo.kidsAtHome }}</span>
            </div>
            <div
              class="detail-row"
              v-if="applicationInfo.kidsInOtherSchool !== null"
            >
              <span class="label">?האט איר קינדער אין אנדערע מוסדות:</span>
              <span>{{
                applicationInfo.kidsInOtherSchool ? "Yes" : "No"
              }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.otherSchool">
              <span class="label">נאמען פון מוסד:</span>
              <span>{{ applicationInfo.otherSchool }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.playGroup">
              <span class="label">Play Group:</span>
              <span>{{ applicationInfo.playGroup }}</span>
            </div>
          </div>

          <!-- Benefits & Programs -->
          <div class="mb-3">
            <div class="font-weight-bold mb-2">Benefits & Programs</div>
            <div
              v-if="
                !applicationInfo.foodStampCase &&
                  !applicationInfo.vouchers &&
                  !applicationInfo.note
              "
              class="text--secondary"
              style="font-size: 12px; font-style: italic;"
            >
              No info filled...
            </div>
            <div class="detail-row" v-if="applicationInfo.foodStampCase">
              <span class="label">Food Stamp Case #:</span>
              <span>{{ applicationInfo.foodStampCase }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.vouchers">
              <span class="label">Vouchers:</span>
              <span>{{ applicationInfo.vouchers }}</span>
            </div>
            <div class="detail-row" v-if="applicationInfo.note">
              <span class="label">Note:</span>
              <span style="white-space: pre-wrap;">{{
                applicationInfo.note
              }}</span>
            </div>
          </div>
        </v-flex>
          </v-layout>
        </div>
      </div>
    </div>

    <v-dialog
      persistent
      v-model="kollelApplicationDialog"
      :max-width="kollelApplicationDialogWidth"
    >
      <v-card class="pa-4">
        <v-card-title class="headline px-0 mb-2 pt-0"
          >Kollel Application</v-card-title
        >
        <v-form ref="form">
          <v-layout row>
            <v-btn
              small
              class="mb-3 mt-0"
              color="success"
              :loading="uploading"
              style="height: 35px;"
              @click="pickFile()"
              ><v-icon dark left>mdi-cloud-upload</v-icon>Upload</v-btn
            >
            <!-- <div class="mt-2 ml-2">
                            Application Status:
                            {{
                                kollelApplicationDocuments.length
                                    ? "Uploaded"
                                    : "Not Uploaded"
                            }}
                        </div> -->
            <input
              type="file"
              style="display: none"
              ref="files"
              accept="image/*,.pdf"
              @change="onFilePicked($event)"
            />
            <v-btn
              v-if="kollelApplication.documentURL"
              small
              class="mt-0 ml-3"
              @click="openDocument()"
              style="height: 35px;"
            >
              <v-icon color="red" left dark>mdi-file-pdf</v-icon>
              <span class="mr-2">Kollel Application</span>
              <v-icon right>mdi-download</v-icon>
            </v-btn>
            <v-btn
              class="mt-0"
              v-if="kollelApplication.documentURL"
              small
              icon
              @click.stop="deleteDocument()"
              ><v-icon color="red">mdi-delete-forever</v-icon></v-btn
            >
          </v-layout>
          <div style="overflow-y: auto; height: 500px">
            <v-layout row>
              <div class="font-weight-medium mr-2">
                Name:
              </div>
              <div>{{ kollelApplication.name }}</div>
              <v-spacer></v-spacer>
              <div class="font-weight-medium mr-2">
                Address:
              </div>
              <div>{{ kollelApplication.address }}</div>
              <v-spacer></v-spacer>
              <div class="font-weight-medium mr-2">
                Phone:
              </div>
              <div>{{ kollelApplication.homePhone }}</div>
            </v-layout>
            <v-divider
              style="border-color: #4caf50; margin-top: 13px;"
              class="mt-2 pt-2"
            ></v-divider>
            <v-layout row>
              <v-select
                color="success"
                :items="['ניין', 'יא']"
                v-model="kollelApplication.onKollelPayroll"
                class="mb-0 mt-2"
                :rules="required"
                reverse
                label="באקומט כולל געלט
"
              ></v-select>
              <v-select
                color="success"
                :items="['ניין', 'יא']"
                v-model="kollelApplication.kollelTimeAllDay"
                class="mb-0 mt-2 ml-3"
                :rules="required"
                reverse
                label="לערנט איר אין כולל א גאנצן טאג"
              ></v-select>
            </v-layout>
            <v-layout row class="pa-0 ma-0">
              <v-divider
                style="border-color: #4caf50; margin-top: 13px;"
                class="mt-2 pt-2"
              ></v-divider>
              <div class="font-weight-medium ml-2">
                כולל לשנת תשפ"ג
              </div>
            </v-layout>
            <v-layout row justify-end align-end>
              <v-spacer></v-spacer>
              <v-radio-group
                v-model="kollelApplication.kollelType"
                row
                style="max-width: 326px;"
              >
                <v-radio
                  label="כולל אברכים תורה ויראה"
                  value="satmar"
                  color="success"
                ></v-radio>
                <v-radio
                  label="אנדערע כולל"
                  value="other"
                  color="success"
                ></v-radio>
              </v-radio-group>
            </v-layout>
            <v-layout row justify-end align-end>
              <v-spacer></v-spacer>
              <v-select
                v-if="kollelApplication.kollelType == 'satmar'"
                color="success"
                style="max-width: 300px;"
                :items="satmarKollelNames"
                v-model="kollelApplication.kollelName"
                class="my-0 pt-0"
                reverse
                :rules="required"
                label="כולל אברכים תורה ויראה"
              ></v-select>
            </v-layout>

            <div v-if="kollelApplication.kollelType == 'other'">
              <v-layout row>
                <v-text-field
                  autocomplete="new-password"
                  label="כולל אדרעס"
                  v-model="kollelApplication.kollelAddress"
                  ref="kollelAddress"
                  :rules="required"
                  reverse
                ></v-text-field>
                <v-text-field
                  autocomplete="new-password"
                  label="נאמען פון כולל"
                  v-model="kollelApplication.kollelName"
                  ref="kollelName"
                  :rules="required"
                  class="ml-3"
                  reverse
                ></v-text-field>
              </v-layout>
              <v-layout row>
                <v-text-field
                  autocomplete="new-password"
                  label="ראש הכולל סעלפאן"
                  v-model="kollelApplication.roshHakollelPhone"
                  ref="roshHakollelPhone"
                  :rules="required"
                  reverse
                ></v-text-field>
                <v-text-field
                  autocomplete="new-password"
                  class="ml-3"
                  label="ראש הכולל"
                  v-model="kollelApplication.roshHakollel"
                  ref="roshHakollel"
                  :rules="required"
                  reverse
                ></v-text-field>
              </v-layout>
            </div>
            <v-layout row class="pa-0 ma-0">
              <v-divider
                style="border-color: #4caf50; margin-top: 13px;"
                class="mt-2 pt-2"
              ></v-divider>
              <div class="font-weight-medium ml-2">
                נאכמיטאג כולל
              </div>
            </v-layout>
            <v-layout row justify-end align-end>
              <v-spacer></v-spacer>
              <v-radio-group
                v-model="kollelApplication.kollelType2"
                row
                style="max-width: 326px"
              >
                <v-radio
                  label="כולל אברכים תורה ויראה"
                  value="satmar"
                  color="success"
                ></v-radio>
                <v-radio
                  label="אנדערע כולל"
                  value="other"
                  color="success"
                ></v-radio>
              </v-radio-group>
            </v-layout>
            <v-layout row justify-end align-end>
              <v-spacer></v-spacer>
              <v-select
                v-if="kollelApplication.kollelType2 == 'satmar'"
                color="success"
                style="max-width: 300px;"
                :items="satmarKollelNames"
                v-model="kollelApplication.kollelName2"
                class="my-0 pt-0"
                reverse
                label="כולל אברכים תורה ויראה"
              ></v-select>
            </v-layout>

            <div v-if="kollelApplication.kollelType2 == 'other'">
              <v-layout row>
                <v-text-field
                  autocomplete="new-password"
                  label="כולל אדרעס"
                  v-model="kollelApplication.kollelAddress2"
                  ref="kollelAddress2"
                  reverse
                ></v-text-field>
                <v-text-field
                  autocomplete="new-password"
                  label="נאמען פון כולל"
                  v-model="kollelApplication.kollelName2"
                  ref="kollelName2"
                  reverse
                  class="ml-3"
                ></v-text-field>
              </v-layout>
              <v-layout row>
                <v-text-field
                  autocomplete="new-password"
                  label="ראש הכולל סעלפאן"
                  v-model="kollelApplication.roshHakollelPhone2"
                  ref="roshHakollelPhone2"
                  reverse
                  :rules="required"
                ></v-text-field>
                <v-text-field
                  autocomplete="new-password"
                  label="ראש הכולל"
                  v-model="kollelApplication.roshHakollel2"
                  ref="roshHakollel2"
                  reverse
                  class="ml-3"
                ></v-text-field>
              </v-layout>
            </div>

            <v-layout row class="pa-0 ma-0">
              <v-divider
                style="border-color: #4caf50; margin-top: 13px;"
                class="mt-2 pt-2"
              ></v-divider>
              <div class="font-weight-medium ml-2">
                פרנסה
              </div>
            </v-layout>
            <v-layout row justify-end align-end>
              <v-spacer></v-spacer>
              <v-select
                color="success"
                reverse
                :items="['ניין', 'יא']"
                v-model="kollelApplication.wifeHasJob"
                class="my-0"
                style="max-width: 300px;"
                :rules="required"
                label="האט די בעה'ב'סטע א דזשאב/פרנסה"
              ></v-select>
            </v-layout>
            <v-layout row v-if="kollelApplication.wifeHasJob == 'יא'">
              <v-text-field
                autocomplete="new-password"
                label="וויפיל יאר ארבעט מען דארט"
                type="number"
                v-model="kollelApplication.wivesJobYears"
                ref="wivesJobYears"
                reverse
              ></v-text-field>
              <v-text-field
                autocomplete="new-password"
                label="פאזיצע"
                v-model="kollelApplication.wivesPosition"
                ref="wivesPosition"
                class="ml-3"
                reverse
              ></v-text-field>
              <v-text-field
                autocomplete="new-password"
                label="נאמען פון ביזנעס/בעה''ב"
                v-model="kollelApplication.wivesJob"
                ref="wivesJob"
                class="ml-3"
                reverse
              ></v-text-field>
            </v-layout>
            <v-layout row justify-end align-end>
              <v-spacer></v-spacer>
              <v-select
                color="success"
                :items="['ניין', 'יא']"
                v-model="kollelApplication.hasJob"
                class="my-0"
                :rules="required"
                reverse
                style="max-width: 300px"
                label="זענט איר עוסק אין סיי וועלכע פרנסה"
              ></v-select
            ></v-layout>
            <v-layout row v-if="kollelApplication.hasJob == 'יא'">
              <v-text-field
                autocomplete="new-password"
                label="וועלכע פרנסה זענט איר עוסק"
                v-model="kollelApplication.sideJob"
                ref="sideJob"
                reverse
              ></v-text-field>
            </v-layout>

            <v-text-field
              autocomplete="new-password"
              label="Note"
              v-model="kollelApplication.note"
              ref="note"
            ></v-text-field>
            <!-- <v-select
                                label="Status"
                                :items="[
                                    'SUBMITTED',
                                    'APPROVED FULL KOLLEL',
                                    'APPROVED KOLLEL WITH SIDE INCOME',
                                ]"
                                v-model="kollelApplication.status"
                                ref="status"
                            ></v-select> -->
          </div>
        </v-form>
        <v-card-actions class="mr-0 mt-2 pb-0">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="kollelApplicationDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            color="success"
            :loading="processing"
            @click="saveKollelApllication"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Application Information Edit Dialog -->
    <v-dialog v-model="applicationInfoDialog" max-width="1300" persistent>
      <v-card style="height: 90vh; display: flex; flex-direction: column;">
        <v-card-title class="headline success white--text py-2">
          Application Information
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="closeApplicationInfoDialog"
            class="white--text my-0"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text
          class="pa-2 application-info-dialog-body"
          :class="{
            'application-info-dialog-body--loading':
              applicationInfoOptionsLoading,
          }"
        >
          <div
            v-if="applicationInfoOptionsLoading"
            class="application-info-dialog-loading"
          >
            <v-progress-circular
              indeterminate
              color="success"
              size="48"
            ></v-progress-circular>
            <div class="mt-3 text--secondary">Loading application information...</div>
          </div>

          <!-- 3 Column Layout -->
          <v-layout v-else row wrap>
            <!-- Column 1 -->
            <v-flex xs4 class="pr-4">
              <!-- Father Information -->
              <div
                class="pa-3 mb-3"
                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
              >
                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                  טאטע
                </div>

                <v-combobox
                  ref="fatherCityCombo"
                  v-model="applicationInfoEdit.fatherCity"
                  :items="fatherCityOptions"
                  label="Father City"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-combobox>

                <v-combobox
                  ref="fatherSchoolCombo"
                  v-model="applicationInfoEdit.fatherSchool"
                  :items="fatherSchoolOptions"
                  label="?טאטע איז א תלמיד פון חדר"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-combobox>

                <v-text-field
                  v-model="applicationInfoEdit.fatherYeshivahKetana"
                  label="?טאטע איז א תלמיד פון ישיבה קטנה"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
                <v-text-field
                  v-model="applicationInfoEdit.fatherYeshivahGedolah"
                  label="?טאטע איז א תלמיד פון ישיבה גדולה"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
              </div>

              <!-- Mother Information -->
              <div
                class="pa-3 mb-3"
                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
              >
                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                  מאמע
                </div>

                <v-combobox
                  ref="motherSchoolCombo"
                  v-model="applicationInfoEdit.motherSchool"
                  :items="motherSchoolOptions"
                  label="?מאמע איז תלמידה פון"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-combobox>
                <v-text-field
                  v-model="applicationInfoEdit.motherGraduatedYear"
                  label="?וועלכע יאר גענדיגט די 11 טע קלאס"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
              </div>

              <!-- Landlord -->
              <div
                class="pa-3 mb-3"
                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
              >
                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                  Landlord
                </div>

                <v-text-field
                  v-model="applicationInfoEdit.landlord"
                  label="Landlord"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <v-text-field
                  v-model="applicationInfoEdit.landlordPhone"
                  label="Landlord Phone"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
              </div>

              <!-- Emergency Contact -->
              <div
                class="pa-3 mb-3"
                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
              >
                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                  Emergency Contact
                </div>

                <v-text-field
                  v-model="applicationInfoEdit.inCaseOfEmergencyName"
                  label="Emergency Contact Name"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
                <v-text-field
                  v-model="applicationInfoEdit.inCaseOfEmergencyPhone"
                  label="Emergency Contact Phone #"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
              </div>

              <!-- Country -->
              <div
                class="pa-3 mb-3"
                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
              >
                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                  Country
                </div>

                <v-text-field
                  v-model="applicationInfoEdit.country"
                  label="Country"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
              </div>
            </v-flex>

            <!-- Column 2 -->
            <v-flex xs4 class="pr-4">
              <!-- Work Information -->
              <div
                class="pa-3 mb-3"
                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
              >
                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                  ארבעט
                </div>

                <!-- Father's Work -->
                <div class="font-weight-bold mb-2 mt-2" style="font-size: 13px;">
                  טאטע'ס ארבעט
                </div>

                <v-text-field
                  v-model="applicationInfoEdit.workPlaceOrBoss"
                  label="ארבעט"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
                <v-text-field
                  v-model="applicationInfoEdit.workBoss"
                  label="נאמען פון בעה''ב"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
                <v-select
                  v-model="applicationInfoEdit.workType"
                  label="Work Type"
                  :items="workTypeOptions"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-select>
                <v-text-field
                  v-model="applicationInfoEdit.workAddress"
                  label="Work Address"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
                <v-text-field
                  v-model="applicationInfoEdit.workPhone"
                  label="Work Phone #"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
                <v-combobox
                  ref="workPositionCombo"
                  v-model="applicationInfoEdit.workPosition"
                  :items="workPositionOptions"
                  label="Work Position"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-combobox>
                <v-text-field
                  v-model.number="applicationInfoEdit.yearsInPosition"
                  label="Years In Position"
                  type="number"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <!-- Mother's Work -->
                <div class="font-weight-bold mb-2 mt-3" style="font-size: 13px;">
                  מאמע'ס ארבעט
                </div>

                <v-text-field
                  v-model="applicationInfoEdit.wifeWorkPlaceOrBoss"
                  label="ארבעט"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
                <v-text-field
                  v-model="applicationInfoEdit.wifeWorkBoss"
                  label="נאמען פון בעה''ב"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
                <v-select
                  v-model="applicationInfoEdit.wifeWorkType"
                  label="Work Type"
                  :items="workTypeOptions"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-select>
                <v-text-field
                  v-model="applicationInfoEdit.wifeWorkAddress"
                  label="Work Address"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
                <v-text-field
                  v-model="applicationInfoEdit.wifeWorkPhone"
                  label="Work Phone #"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
                <v-combobox
                  ref="wifeWorkPositionCombo"
                  v-model="applicationInfoEdit.wifeWorkPosition"
                  :items="wifeWorkPositionOptions"
                  label="Work Position"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-combobox>
                <v-text-field
                  v-model.number="applicationInfoEdit.wifeYearsInPosition"
                  label="Years In Position"
                  type="number"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
              </div>
            </v-flex>

            <!-- Column 3 -->
            <v-flex xs4>
              <!-- שול און אידישקייט -->
              <div
                class="pa-3 mb-3"
                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
              >
                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                  ביהמ"ד
                </div>

                <v-text-field
                  v-model="applicationInfoEdit.shabbatSynagogue"
                  label="וואכן ביהמ''ד"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
                <v-text-field
                  v-model="applicationInfoEdit.weekdaySynagogue"
                  label="שבת ביהמ''ד"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
                <v-text-field
                  v-model="applicationInfoEdit.dayan"
                  label="דיין"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>
                <v-checkbox
                  v-model="applicationInfoEdit.isSatmarMember"
                  label="קיט''ל מעמבער"
                  color="success"
                  hide-details
                  class="mt-1 mb-2"
                ></v-checkbox>
              </div>

              <!-- קינדער -->
              <div
                class="pa-3 mb-3"
                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
              >
                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                  קינדער
                </div>

                <v-text-field
                  v-model.number="applicationInfoEdit.kidsAtHome"
                  label="?וויפיל קינדער האט איר אין שטוב"
                  dense
                  hide-details
                  type="number"
                  class="mb-2"
                ></v-text-field>
                <v-checkbox
                  v-model="applicationInfoEdit.kidsInOtherSchool"
                  label="?האט איר קינדער אין אנדערע מוסדות"
                  color="success"
                  hide-details
                  class="mb-2"
                ></v-checkbox>
                <v-combobox
                  ref="otherSchoolCombo"
                  v-model="applicationInfoEdit.otherSchool"
                  :items="otherSchoolOptions"
                  label="נאמען פון מוסד"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-combobox>

                <v-combobox
                  ref="playGroupCombo"
                  v-model="applicationInfoEdit.playGroup"
                  :items="playGroupOptions"
                  label="Play Group"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-combobox>
              </div>

              <!-- Benefits & Programs -->
              <div
                class="pa-3 mb-3"
                style="background-color: #f9f9f9; border: 1px solid #ddd; border-radius: 6px;"
              >
                <div class="font-weight-bold mb-2" style="font-size: 14px;">
                  Benefits & Programs
                </div>

                <v-text-field
                  v-model="applicationInfoEdit.foodStampCase"
                  label="Food Stamp Case #"
                  dense
                  hide-details
                  class="mb-2"
                ></v-text-field>

                <v-select
                  v-model="applicationInfoEdit.vouchers"
                  label="Vouchers"
                  :items="applicationInfoEdit.vouchers && voucherTypeOptions.indexOf(applicationInfoEdit.vouchers) === -1 ? [applicationInfoEdit.vouchers].concat(voucherTypeOptions) : voucherTypeOptions"
                  dense
                  hide-details
                  class="mb-2"
                  clearable
                ></v-select>
                <v-textarea
                  v-model="applicationInfoEdit.note"
                  label="Note"
                  rows="2"
                  outline
                  hide-details
                  class="mb-2"
                ></v-textarea>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="py-2 pr-1 my-2" style="flex-shrink: 0;">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="closeApplicationInfoDialog"
            >Cancel</v-btn
          >
          <v-btn
            color="success"
            @click="saveApplicationInfo"
            :loading="applicationInfoProcessing"
            :disabled="applicationInfoOptionsLoading"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { formatPhoneNumber, except, toTitleCase } from "../../utils/helpers.js";
import { loadOptions } from "../../utils/smLookup.js";
import moment from "moment";

export default {
  props: {
    account: Object,
    registrationRequirments: Array,
    students: Array,
  },
  data() {
    return {
      kollelApplicationDialog: false,
      kollelApplicationDialogWidth: "800",
      processing: false,
      uploading: false,
      files: [],
      kollelForms: [],
      kollelApplicationDocuments: [],

      required: [(value) => !!value || "Required."],

      pdfDucmentNumberOfPages: "",

      pageCount: 0,
      currentPage: 0,

      satmarKollelNames: [
        "סניף תהלות יואל",
        "סניף קליימער",
        "סניף קיעפ קומה א׳",
        "סניף קיעפ קומה ב׳",
        "כולל גפ״ת",
      ],

      kollelApplication: {
        id: "",
        onKollelPayment: "",
        kollelTimeAllDay: "",
        kollelName: "",
        kollelAddress: "",
        kollelTime: "",
        roshHakollel: "",
        kollelName2: "",
        kollelAddress2: "",
        kollelTime2: "",
        roshHakollel2: "",
        hasJob: false,
        sideJob: "",
        wifeHasJob: false,
        wivesJob: "",
        wivesPosition: "",
        wivesJobYears: "",
        note: "",
        status: "SUBMITTED",
        documentURL: "",
        source: "",
        kollelType: "",
        kollelType2: "",
        name: "",
        homePhone: "",
        address: "",
      },

      // Application Info
      applicationInfoExpanded: false,
      applicationInfo: null,
      applicationInfoEdit: {},
      applicationInfoDialog: false,
      applicationInfoProcessing: false,
      applicationInfoOptionsLoading: false,
      applicationInfoLoading: true,
      otherSchoolOptions: [],
      playGroupOptions: [],
      voucherTypeOptions: [],
      motherSchoolOptions: [],
      fatherCityOptions: [],
      fatherSchoolOptions: [],
      workTypeOptions: [],
      workPositionOptions: [],
      wifeWorkPositionOptions: [],
      fatherCitySearch: null,
      fatherSchoolSearch: null,
      otherSchoolSearch: null,
    };
  },
  async created() {
    const response = await this.$http.get(
      "api/kollelForms/getApplication?accountID=" + this.account.accountID
    );

    this.kollelForms = response.kollelForms;

    if (this.$route.query.goToRegistrationKollel) {
      this.openKollelApplication({ id: this.$route.query.kollelFormID });
    }

    // Load application info
    await this.loadApplicationInfo();

    // Load application info dialog options
    await this.refreshApplicationInfoOptions();
  },
  computed: {
    applicationInfoFilledCount() {
      if (!this.applicationInfo) return 0;

      const fields = [
        this.applicationInfo.landlord,
        this.applicationInfo.workPlaceOrBoss,
        this.applicationInfo.workBoss,
        this.applicationInfo.workAddress,
        this.applicationInfo.workPhone,
        this.applicationInfo.workType,
        this.applicationInfo.note,
        this.applicationInfo.workPosition,
        this.applicationInfo.yearsInPosition,
        this.applicationInfo.shabbatSynagogue,
        this.applicationInfo.weekdaySynagogue,
        this.applicationInfo.isSatmarMember,
        this.applicationInfo.dayan,
        this.applicationInfo.inCaseOfEmergencyName,
        this.applicationInfo.inCaseOfEmergencyPhone,
        this.applicationInfo.foodStampCase,
        this.applicationInfo.fatherSchool,
        this.applicationInfo.fatherYeshivahKetana,
        this.applicationInfo.fatherYeshivahGedolah,
        this.applicationInfo.motherSchool,
        this.applicationInfo.motherGraduatedYear,
        this.applicationInfo.kidsAtHome,
        this.applicationInfo.kidsInOtherSchool,
        this.applicationInfo.otherSchool,
        this.applicationInfo.fatherCity,
        this.applicationInfo.wifeWorkPlaceOrBoss,
        this.applicationInfo.wifeWorkBoss,
        this.applicationInfo.wifeWorkAddress,
        this.applicationInfo.wifeWorkPhone,
        this.applicationInfo.wifeWorkType,
        this.applicationInfo.wifeWorkPosition,
        this.applicationInfo.wifeYearsInPosition,
        this.applicationInfo.landlordPhone,
        this.applicationInfo.vouchers,
        this.applicationInfo.playGroup,
        this.applicationInfo.country,
      ];

      return fields.filter((val) => {
        if (val === null || val === undefined) return false;
        const strVal = String(val).trim();
        return strVal !== "" && strVal !== "0";
      }).length;
    },
  },
  methods: {
    formatPhoneNumber(phone) {
      return formatPhoneNumber(phone);
    },
    toggleApplicationInfo() {
      if (this.applicationInfoExpanded) {
        this.applicationInfoExpanded = false;
        return;
      }

      this.expandApplicationInfo();
    },
    expandApplicationInfo() {
      this.applicationInfoExpanded = true;

      this.$nextTick(() => {
        const section = this.$refs.applicationInfoSection;
        if (section && section.scrollIntoView) {
          section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    getRequirmentDescription(requirment) {
      return this.getStudentName(requirment) + requirment.description;
    },
    getStudentName(requirment) {
      if (!this.students.length || !requirment.studentID) return "";

      const student = this.students.find(
        (s) => s.studentID.trim() == requirment.studentID.trim()
      );

      return student
        ? `<span class="font-weight-medium">${student.engName}: </span>`
        : "";
    },
    getStudentProperties(student) {
      return Object.keys(
        except(student, "did", "pin", "hebName", "engName")
      ).map((key) => {
        const value =
          key == "dob"
            ? moment(student[key]).format("MM/DD/YYYY h:mm:ss A")
            : student[key];
        return {
          name: toTitleCase(key),
          value: value,
        };
      });
    },
    pickFile() {
      this.$refs.files.click();
    },
    async onFilePicked(e) {
      this.uploading = true;

      const files = e.target.files;

      if (!files) return;

      try {
        var formData = new FormData();

        this.files = files;

        formData.append("upload_file", this.files[0]);

        const response = await this.$http.post(
          "api/kollelForms/uploadKollelApplication?accountID=" +
            this.account.accountID,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        this.kollelApplication.documentURL = response;
        //this.kollelApplicationDialogWidth = 1200;

        //this.updatePdfPages();

        this.uploading = false;
      } catch (e) {
        this.uploading = false;
      }
    },
    updatePdfPages() {
      pdfjsLib.getDocument(this.kollelApplication.documentURL).then((doc) => {
        this.pdfDucmentNumberOfPages = doc.numPages;
        console.log(doc.numPages);
      });
    },
    openDocument() {
      window.open(this.kollelApplication.documentURL);
    },
    deleteDocument() {
      this.kollelApplication.documentURL = "";
    },
    async openKollelApplication({ id = null }) {
      //this.kollelApplicationDocuments = response.kollelDocuments || [];

      // this.kollelApplication.name = this.account.hname;
      // this.kollelApplication.homePhone = this.account.homePhone;
      // this.kollelApplication.address = this.account.address1;

      const form = id
        ? this.kollelForms.find((f) => f.id == id)
        : this.kollelForms.length
        ? this.kollelForms[0]
        : undefined;

      if (!id && this.kollelForms.length == 1) {
        id = this.kollelForms[0].id;
      }

      // if (form) {
      //     this.kollelApplication.id = form.id;
      //     this.kollelApplication.onKollelPayroll = form.onKollelPayroll;
      //     this.kollelApplication.kollelTimeAllDay =
      //         form.kollelTime == "allday"
      //             ? "יא"
      //             : form.kollelTime == "morning"
      //             ? "ניין"
      //             : "";
      //     this.kollelApplication.kollelName = form.kollelName;
      //     this.kollelApplication.kollelType = form.kollelType;
      //     this.kollelApplication.kollelType2 = form.kollelType2;
      //     this.kollelApplication.kollelAddress = form.kollelAddress;
      //     this.kollelApplication.kollelTime = form.kollelTime;
      //     this.kollelApplication.roshHakollel = form.roshHakollel;
      //     this.kollelApplication.kollelName2 = form.kollelName2;
      //     this.kollelApplication.kollelAddress2 = form.kollelAddress2;
      //     this.kollelApplication.kollelTime2 = form.kollelTime2;
      //     this.kollelApplication.roshHakollel2 = form.roshHakollel2;
      //     this.kollelApplication.hasJob = form.hasJob;
      //     this.kollelApplication.sideJob = form.sideJob;
      //     this.kollelApplication.wifeHasJob = form.wifeHasJob;
      //     this.kollelApplication.wivesJob = form.wivesJob;
      //     this.kollelApplication.wivesPosition = form.wivesPosition;
      //     this.kollelApplication.wivesJobYears = form.wivesJobYears;
      //     this.kollelApplication.note = form.note;
      //     this.kollelApplication.status = form.status;
      //     this.kollelApplication.documentURL = form.documentURL;
      //     this.kollelApplication.source = form.source;
      // }

      this.$router.push(
        "/kollel-application/" +
          this.account.accountID +
          (id ? "/" + id.toString() : "")
      );
    },
    collectFormData() {
      return {
        id: this.kollelApplication.id || 0,
        date: moment().format("YYYY-MM-DD HH:mm:ss"),
        accountID: this.account.accountID,
        name: this.account.hname,
        homePhone: this.account.homePhone.replace(/\D/g, ""),
        address: this.account.address1,
        cellphone: this.account.cellPhone.replace(/\D/g, ""),
        father: this.account.father,
        fatherInLaw: this.account.shver,
        kollelName: this.kollelApplication.kollelName,
        kollelAddress: this.kollelApplication.kollelAddress,
        kollelTime:
          this.kollelApplication.kollelTimeAllDay == "יא"
            ? "allday"
            : "morning",
        roshHakollel: this.kollelApplication.roshHakollel,
        kollelName2: this.kollelApplication.kollelName2,
        kollelAddress2: this.kollelApplication.kollelAddress2,
        kollelTime2: this.kollelApplication.kollelTime2,
        kollelType: this.kollelApplication.kollelType,
        kollelType2: this.kollelApplication.kollelType2,
        roshHakollel2: this.kollelApplication.roshHakollel2,
        onKollelPayroll: this.kollelApplication.onKollelPayroll,
        documentURL: this.kollelApplication.documentURL,
        sideJob: this.kollelApplication.hasJob
          ? this.kollelApplication.sideJob
          : null,
        wifeHasJob: this.kollelApplication.wifeHasJob,
        hasJob: this.kollelApplication.hasJob,
        wivesJob: this.kollelApplication.wifeHasJob
          ? this.kollelApplication.wivesJob
          : null,
        wivesPosition: this.kollelApplication.wifeHasJob
          ? this.kollelApplication.wivesPosition
          : null,
        wivesJobYears: this.kollelApplication.wifeHasJob
          ? this.kollelApplication.wivesJobYears
          : null,
        source: this.kollelApplication.source
          ? this.kollelApplication.source
          : "ADMIN PORTAL",
        status: this.kollelApplication.status,
        note: this.kollelApplication.note,
        updatedBy: this.$store.state.authentication.user,
      };
    },
    async saveKollelApllication() {
      if (!this.$refs.form.validate(true)) return;

      if (
        !this.kollelApplication.documentURL &&
        this.kollelApplication.source != "DDC"
      ) {
        return this.$notify({
          text: "Please Upload Application",
          group: "notification",
          type: "error",
        });
      }

      try {
        this.processing = true;

        const response = await this.$http.post(
          "api/kollelForms/fillKollelForm",
          this.collectFormData()
        );

        this.processing = false;
        this.kollelApplicationDialog = false;
      } catch (e) {
        this.processing = false;
      }
    },
    async loadApplicationInfo() {
      this.applicationInfoLoading = true;
      try {
        const response = await this.$http.get(
          "api/newfamilyapplications/GetApplicationByAccountID?accountid=" +
            this.account.accountID
        );
        this.applicationInfo = response || {};
      } catch (e) {
        console.error("Failed to load application info", e);
        this.applicationInfo = {};
      } finally {
        this.applicationInfoLoading = false;
      }
    },
    async openApplicationInfoDialog() {
      this.applicationInfoEdit = {
        personID: this.applicationInfo.personID || "",
        accountID: this.account.accountID,
        landlord: this.applicationInfo.landlord || "",
        landlordPhone: this.applicationInfo.landlordPhone || "",
        workPlaceOrBoss: this.applicationInfo.workPlaceOrBoss || "",
        workBoss: this.applicationInfo.workBoss || "",
        workAddress: this.applicationInfo.workAddress || "",
        workPhone: this.applicationInfo.workPhone || "",
        workType: this.applicationInfo.workType || "",
        workPosition: this.applicationInfo.workPosition || "",
        yearsInPosition: this.applicationInfo.yearsInPosition || null,
        note: this.applicationInfo.note || "",
        shabbatSynagogue: this.applicationInfo.shabbatSynagogue || "",
        weekdaySynagogue: this.applicationInfo.weekdaySynagogue || "",
        isSatmarMember: this.applicationInfo.isSatmarMember || false,
        dayan: this.applicationInfo.dayan || "",
        inCaseOfEmergencyName: this.applicationInfo.inCaseOfEmergencyName || "",
        inCaseOfEmergencyPhone:
          this.applicationInfo.inCaseOfEmergencyPhone || "",
        foodStampCase: this.applicationInfo.foodStampCase || "",
        vouchers: this.applicationInfo.vouchers || "",
        fatherCity: this.applicationInfo.fatherCity || "",
        fatherSchool: this.applicationInfo.fatherSchool || "",
        fatherYeshivahKetana: this.applicationInfo.fatherYeshivahKetana || "",
        fatherYeshivahGedolah: this.applicationInfo.fatherYeshivahGedolah || "",
        motherSchool: this.applicationInfo.motherSchool || "",
        motherGraduatedYear: this.applicationInfo.motherGraduatedYear || "",
        kidsAtHome: this.applicationInfo.kidsAtHome || null,
        kidsInOtherSchool: this.applicationInfo.kidsInOtherSchool || false,
        otherSchool: this.applicationInfo.otherSchool || "",
        playGroup: this.applicationInfo.playGroup || "",
        wifeWorkPlaceOrBoss: this.applicationInfo.wifeWorkPlaceOrBoss || "",
        wifeWorkBoss: this.applicationInfo.wifeWorkBoss || "",
        wifeWorkType: this.applicationInfo.wifeWorkType || "",
        wifeWorkAddress: this.applicationInfo.wifeWorkAddress || "",
        wifeWorkPhone: this.applicationInfo.wifeWorkPhone || "",
        wifeWorkPosition: this.applicationInfo.wifeWorkPosition || "",
        wifeYearsInPosition: this.applicationInfo.wifeYearsInPosition || null,
        country: this.applicationInfo.country || "",
      };
      this.applicationInfoOptionsLoading = true;
      this.applicationInfoDialog = true;

      try {
        await this.refreshApplicationInfoOptions();
      } finally {
        this.applicationInfoOptionsLoading = false;
      }
    },
    closeApplicationInfoDialog() {
      this.applicationInfoDialog = false;
      this.applicationInfoEdit = {};
    },
    async saveApplicationInfo() {
      try {
        this.applicationInfoProcessing = true;
        
        // Extract typed values from comboboxes
        if (this.$refs.fatherCityCombo && this.$refs.fatherCityCombo.internalSearch) {
          this.applicationInfoEdit.fatherCity = this.$refs.fatherCityCombo.internalSearch;
        }
        if (this.$refs.fatherSchoolCombo && this.$refs.fatherSchoolCombo.internalSearch) {
          this.applicationInfoEdit.fatherSchool = this.$refs.fatherSchoolCombo.internalSearch;
        }
        if (this.$refs.otherSchoolCombo && this.$refs.otherSchoolCombo.internalSearch) {
          this.applicationInfoEdit.otherSchool = this.$refs.otherSchoolCombo.internalSearch;
        }
        if (this.$refs.playGroupCombo && this.$refs.playGroupCombo.internalSearch) {
          this.applicationInfoEdit.playGroup = this.$refs.playGroupCombo.internalSearch;
        }
        if (this.$refs.motherSchoolCombo && this.$refs.motherSchoolCombo.internalSearch) {
          this.applicationInfoEdit.motherSchool = this.$refs.motherSchoolCombo.internalSearch;
        }
        if (this.$refs.workPositionCombo && this.$refs.workPositionCombo.internalSearch) {
          this.applicationInfoEdit.workPosition = this.$refs.workPositionCombo.internalSearch;
        }
        if (this.$refs.wifeWorkPositionCombo && this.$refs.wifeWorkPositionCombo.internalSearch) {
          this.applicationInfoEdit.wifeWorkPosition = this.$refs.wifeWorkPositionCombo.internalSearch;
        }
        
        await this.$http.post(
          "api/applicantStudents/SaveApplicationInfo",
          this.applicationInfoEdit
        );

        // Reload application info
        await this.loadApplicationInfo();
        this.$emit("application-info-saved", this.applicationInfoFilledCount);

        this.applicationInfoDialog = false;

        this.$notify({
          text: "Application Information Saved",
          group: "notification",
          type: "success",
        });
      } catch (e) {
        this.$notify({
          text: "Failed to save application information",
          group: "notification",
          type: "error",
        });
      } finally {
        this.applicationInfoProcessing = false;
      }
    },
    async loadOtherSchoolOptions() {
      try {
        const response = await this.$http.get(
          "api/newfamilyapplications/GetUniquePropertyValues?propertyName=OtherSchool"
        );
        this.otherSchoolOptions = response || [];
      } catch (e) {
        console.error("Failed to load other school options", e);
        this.otherSchoolOptions = [];
      }
    },
    async refreshApplicationInfoOptions() {
      await Promise.all([
        this.loadOtherSchoolOptions(),
        this.loadPlayGroupOptions(),
        this.loadVoucherTypeOptions(),
        this.loadMotherSchoolOptions(),
        this.loadFatherCityOptions(),
        this.loadFatherSchoolOptions(),
        this.loadWorkTypeOptions(),
        this.loadWorkPositionOptions(),
        this.loadWifeWorkPositionOptions(),
      ]);
    },
    async loadFatherCityOptions() {
      try {
        const response = await this.$http.get(
          "api/newfamilyapplications/GetUniquePropertyValues?propertyName=FatherCity"
        );
        this.fatherCityOptions = response || [];
      } catch (e) {
        console.error("Failed to load father city options", e);
        this.fatherCityOptions = [];
      }
    },
    async loadMotherSchoolOptions() {
      try {
        const response = await this.$http.get(
          "api/newfamilyapplications/GetUniquePropertyValues?propertyName=MotherSchool"
        );
        this.motherSchoolOptions = response || [];
      } catch (e) {
        console.error("Failed to load mother school options", e);
        this.motherSchoolOptions = [];
      }
    },
    async loadFatherSchoolOptions() {
      try {
        const response = await this.$http.get(
          "api/newfamilyapplications/GetUniquePropertyValues?propertyName=FatherSchool"
        );
        this.fatherSchoolOptions = response || [];
      } catch (e) {
        console.error("Failed to load father school options", e);
        this.fatherSchoolOptions = [];
      }
    },
    async loadWorkTypeOptions() {
      try {
        const options = await loadOptions("ApplicantWorkType");
        this.workTypeOptions = options.map(o => o.value);
      } catch (e) {
        console.error("Failed to load work type options", e);
        this.workTypeOptions = [];
      }
    },
    async loadWorkPositionOptions() {
      try {
        const response = await this.$http.get(
          "api/newfamilyapplications/GetUniquePropertyValues?propertyName=WorkPosition"
        );
        this.workPositionOptions = response || [];
      } catch (e) {
        console.error("Failed to load work position options", e);
        this.workPositionOptions = [];
      }
    },
    async loadWifeWorkPositionOptions() {
      try {
        const response = await this.$http.get(
          "api/newfamilyapplications/GetUniquePropertyValues?propertyName=WifeWorkPosition"
        );
        this.wifeWorkPositionOptions = response || [];
      } catch (e) {
        console.error("Failed to load wife work position options", e);
        this.wifeWorkPositionOptions = [];
      }
    },
    async loadPlayGroupOptions() {
      try {
        const response = await this.$http.get(
          "api/newfamilyapplications/GetUniquePropertyValues?propertyName=PlayGroup"
        );
        this.playGroupOptions = response || [];
      } catch (e) {
        console.error("Failed to load play group options", e);
        this.playGroupOptions = [];
      }
    },
    async loadVoucherTypeOptions() {
      try {
        const options = await loadOptions("VoucherType");
        this.voucherTypeOptions = (options || [])
          .map((o) => (typeof o === "string" ? o : o && (o.value || o.text || o.name)))
          .filter((o) => !!o);
      } catch (e) {
        console.error("Failed to load voucher type options", e);
        this.voucherTypeOptions = [];
      }
    },
  },
};
</script>
<style>
.card-width {
  max-width: 65%;
}
.detail-row {
  display: flex;
  margin-bottom: 4px;
  font-size: 12px;
}
.detail-row .label {
  font-weight: 500;
  margin-right: 8px;
  min-width: 180px;
  flex-shrink: 0;
}
.application-info-section {
  margin-left: 8px;
  margin-right: 8px;
  margin-bottom: 8px;
}
.application-info-toggle {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  padding: 6px 10px 6px 4px;
  border-radius: 4px;
}
.application-info-toggle:hover {
  background: #e8f5e9;
}
.application-info-toggle-title,
.application-info-box-title {
  color: #4caf50;
  font-size: 15px;
  font-weight: 500;
}
.application-info-box {
  width: 100%;
  background: #fafafa;
  border: 1px solid #d7e3d8;
  border-radius: 8px;
  overflow: hidden;
}
.application-info-box-header {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px 12px;
  background: #f1f8f2;
  border-bottom: 1px solid #d7e3d8;
}
.application-info-box-title {
  font-size: 16px;
  font-weight: 600;
}
.application-info-caret {
  margin-top: 1px;
}
.application-info-dialog-body {
  flex: 1;
  overflow-y: auto;
}
.application-info-dialog-body--loading {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.application-info-dialog-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
}
</style>
